export function missingRequiredFields(requiredFields: string[], formData): boolean {
    const empty = Object.keys(formData).filter((k) => !formData[k]);
    return requiredFields.some((field: string) => empty.includes(field));
}
